import * as React from "react";
import { getRange } from "../Services/ArrayUtils";
import { isIE } from "../Services/BrowserDetector";

export interface IBirthYearSliderProps {
    minValue: number;
    maxValue: number;
    yearInputPlaceholder: string;
    monthInputLabel: string;
    onBirthYearSelection: any;
    onBirthMonthSelection: any;
    selectedYear: number;
    selectedMonth: number;
}

export const BirthTimeSelector: React.FC<IBirthYearSliderProps> = ({
    maxValue,
    minValue,
    onBirthYearSelection,
    onBirthMonthSelection,
    selectedYear,
    selectedMonth,
    yearInputPlaceholder,
    monthInputLabel,
}) => {
    const months = getRange(1, 12).map((month) => (
        <option key={month} value={month}>
            {month}
        </option>
    ));

    const years = getRange(minValue, maxValue).map((year) => (
        <option key={year} value={year}>
            {year}
        </option>
    ));

    const handleSelectYearChange = (event: any) => {
        onBirthYearSelection(event as React.ChangeEvent<HTMLInputElement>);
    };

    const iePresence = isIE();
    const yearSliderCssClass = iePresence ? "form-group d-none" : "form-group d-none d-md-block";
    const yearSelectCssClass = iePresence ? "form-group d-block" : "form-group d-block d-md-none";

    return (
        <div className="age-wrapper">
            <div className={yearSelectCssClass}>
                <label>{yearInputPlaceholder}<br />
                <select value={selectedYear} className="selectYear" onChange={handleSelectYearChange}>
                    {years}
                </select>
</label>
            </div>
            <div className={yearSliderCssClass}>
                <input
                    type="number"
                    className="year-input"
                    onChange={onBirthYearSelection}
                    value={selectedYear >= minValue ? selectedYear : ""}
                    min={minValue}
                    max={maxValue}
                    placeholder={yearInputPlaceholder}
                    aria-label="year input"
                />
                <span className="slider-start-label">{minValue}</span>
                <span className="slider-end-label">{maxValue}</span>
                <input
                    id="yearRange"
                    onChange={onBirthYearSelection}
                    type="range"
                    name="size"
                    value={selectedYear}
                    min={minValue}
                    max={maxValue}
                    step="1"
                    aria-label="year range"
                />
            </div>
            <label>
                {monthInputLabel}
                <br />
                <select id="months" className="selectMonth" value={selectedMonth} onChange={onBirthMonthSelection}>
                    {months}
                </select>
            </label>
        </div>
    );
};

export default BirthTimeSelector;
